import { createClientManager, HttpError } from "@/http/lib";
import { maintainWebsiteHandler } from "./handlers";

export const manager = createClientManager({
  timeout: 30 * 1000,
});

manager.requestInterceptors.clientFront.use(
  (config) => {
    if (config.headers == undefined) {
      config.headers = {};
    }

    config.headers["via-verify-web-version"] =
      process.env.VUE_APP_VERIFY_WEB_VERSION;

    config.headers["via-agent"] = "com.viatech.serverful.web";
    return config;
  },
  (error) => Promise.reject(new HttpError(error))
);

manager.requestInterceptors.clientPost.use(
  (config) => config,
  (error) => Promise.reject(new HttpError(error))
);

manager.responseInterceptors.clientFront.use(
  (response) => response,
  (error) => Promise.reject(new HttpError(error))
);

manager.responseInterceptors.clientPost.use(
  (response) => response,
  (error) => {
    maintainWebsiteHandler(error, manager.getVueInstance());
    return Promise.reject(new HttpError(error));
  }
);
